import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'

import Button from '@material-ui/core/Button';
import Chip from '@material-ui/core/Chip';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import Divider from '@material-ui/core/Divider';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Icon from '@material-ui/core/Icon';

import MetaBox from './inputs/MetaBox'
import TextInput from './inputs/TextInput'
import CompetencySubForm from './CompetencySubForm'

import {
  get_template,
  clear_template
} from '../actions'

const mapStateToProps = state => {
  return {
    current_user: state.auth.current_user.data,
    fetching: state.template.fetching_single,
    fetched_template: state.template.template,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    getTemplate: (id) => dispatch( get_template(id) ),
    clearTemplate: () => dispatch( clear_template() )
  }
}

class ConnectedTemplatePreview extends React.Component {

  componentDidUpdate(prevProps, prevState) {
    if (this.props.template_id !== prevProps.template_id && this.props.template_id !== null && this.props.template_id !== undefined ) {
      this.props.getTemplate(this.props.template_id)
    }
    if (this.props.template_id && this.props.fetching) {
      document.body.classList.add('instalevel-fetching-data')
    }
    if (prevProps.fetching && !this.props.fetching) {
      document.body.classList.remove('instalevel-fetching-data')
    }
  }

  render() {

    if (this.props.template_id && this.props.fetching) {
      return ''
    }


    if ( !this.props.version && !this.props.template && (!this.props.fetched_template.id || this.props.fetching )) {
      return ''
    }

    const template = this.props.version ? this.props.version : this.props.template ? this.props.template : this.props.fetched_template

    const { creator, name, number_questions, minutes, skill, modifier } = template

    const { levels, competencies, tags, businesses } = this.props.template ? this.props.template : this.props.version ? this.props.version : this.props.fetched_template

    const skillName = typeof skill === "object" ? skill.name : skill

    const {isopen, handleClose} = this.props

    if ( name === undefined || name === null || name.trim() === '' ) {
      return ''
    }

    return (
      <Dialog
        className="dialog-wrapper"
        fullScreen={false}
        fullWidth={true}
        maxWidth={'md'}
        open={isopen}
        onClose={handleClose}
      >
        <DialogContent className="dialog-content">

          <div>
            <Grid container spacing={24} justify="space-between" alignItems="center">
              <Grid item xs={12} md={6}>
                <Typography className="body1 c-black087 mb-8 lh-28">NAME</Typography>
                <Typography className="subtitle2 c-black087 lh-24">{name}</Typography>
                { this.props.version && (
                    <Typography className="subtitle2 c-black087 lh-24">Version ID: {this.props.version.shortid}</Typography>
                )}

                <Typography className="body1 c-black087 mt-24 mb-4 lh-28">SKILL</Typography>
                <Typography className="subtitle2 c-black087 mb-24 lh-24">{skillName}</Typography>

                <Typography className="body1 c-black087 mb-4 lh-28">OPTIONS</Typography>
                <div className="mb-24 c-black087 body2">
                  <span className="d-inline-block">Number of Questions: </span> {number_questions}
                </div>
                <div className="mb-24 c-black087 body2">
                  <span className="d-inline-block">Test Time Limit: </span> {minutes} minutes
                </div>
              </Grid>
              <Grid item xs={12} md={6}>
                <Grid container spacing={24} justify="space-between">
                  <Grid item xs={12} md={12} style={{paddingBottom: 0, marginBottom: -24}}>
                    <Typography className="h6 mb-24">Published Questions in Pool: {template.available_questions}</Typography>
                  </Grid>
                  { levels && levels.map( (n, index) => {

                      return (
                        <Grid item xs={6} md={4} key={`metabox_${index}`}>
                          <MetaBox
                            key={index}
                            index={index}
                            title={n.name}
                            value={n.questions}
                          />
                        </Grid>
                      )
                    })
                  }
                </Grid>
              </Grid>
            </Grid>

            {
              ((tags && tags.length > 0) || (businesses && businesses.length > 0)) && (
                <React.Fragment>
                  <hr className="bg-divider preview-divider" />

                  <Grid container spacing={16} justify="space-between" alignItems="flex-start">

                    {
                      tags && tags.length > 0 && (
                        <Grid item xs={12} md={6} container direction="column">
                          <Typography className="body1 c-black087 mb-8 lh-28">TAGS:</Typography>
                          <Grid container spacing={16} >
                            {
                              tags.map( tag => {
                                return (
                                  <Grid item key={tag.value}>
                                    <Chip label={tag.label} style={{width: "120px", textAlign: 'left'}} />
                                  </Grid>
                                )
                              })
                            }
                          </Grid>
                        </Grid>
                      )
                    }

                    {
                      businesses && businesses.length > 0 && (
                        <Grid item xs={12} md={6} container direction="column">
                          <Typography className="body1 c-black087 mb-8 lh-28">B2B:</Typography>
                          <Grid container spacing={16} >
                            {
                              businesses.map( business => {
                                return (
                                  <Grid item key={business.value}>
                                    <Chip label={business.label} style={{width: "120px", textAlign: 'left'}} />
                                  </Grid>
                                )
                              })
                            }
                          </Grid>
                        </Grid>
                      )
                    }
                  </Grid>
                </React.Fragment>
              )
            }

            {
              this.props.current_user.role === 'admin' && levels && (
                <React.Fragment>
                  <hr className="bg-divider preview-divider" />
                  <Typography className="body1 c-black087 lh-28">LEVELS</Typography>
                  { levels &&
                    levels.map(level => {
                      const { name, msr, level_up, level_down, score_right, score_wrong, min_average } = level
                      const inputData = {
                        score_right: [ score_right, "Pts Correct" ],
                        score_wrong: [ score_wrong, "Pts Wrong" ],
                        msr: [ msr, "MSR %" ],
                        min_average: [ min_average, "Min AVG" ],
                        level_up: [ level_up, <span>#Qs <Icon style={{fontSize: '16px'}}>arrow_upward</Icon></span> ],
                        level_down: [ level_down, <span>#Qs <Icon style={{fontSize: '16px'}}>arrow_downward</Icon></span> ]
                      }
                      return (
                        <Grid container key={`level_${level.name}`}>
                          <Grid container item xl={12}>
                            <div className="d-flex align-items-center cefr-level-wrapper">
                            <div className="cefr-level cefr-level2 fw-bold body1 level-name">{name}</div>

                            {
                              Object.keys(inputData).map( (key, index) => {
                                const item = inputData[key]
                                return (
                                  <div key={`${key}_${index}`} className="small-input">
                                    <TextInput
                                      InputProps={{
                                        readOnly: true
                                      }}
                                      className="miniInput"
                                      defaultValue={item[0]}
                                      nocontrol={true}
                                      helperText={item[1]}
                                    />
                                  </div>
                                )
                              })
                            }
                          </div>

                        </Grid>
                      </Grid>
                      )
                    })
                  }
                </React.Fragment>
              )
            }

            {
              competencies && (
                <React.Fragment>
                  <hr className="bg-divider preview-divider" />
                  <Typography className="body1 c-black087 lh-28">Competency Occurence</Typography>
                  {
                    competencies.map(competency => {
                      return (
                        <CompetencySubForm
                          numOfCols={6}
                          key={`competency-${competency.id}`}
                          competency={competency}
                          base="preview"
                          totalRatio={competencies.map(a=>a.ratio).reduce((a,b)=>parseInt(a,10)+parseInt(b,10))}
                          handleCompetency={(e, f, g) => {
                            e.preventDefault()
                          }}
                        />
                      )
                    })
                  }
                </React.Fragment>
              )
            }


            {
              (!this.props.is_static || this.props.version) && (
                <React.Fragment>
                  <hr className="bg-divider preview-divider" />

                  <Typography className="body1 c-black087 mb-8 lh-28">META</Typography>

                  {
                    !this.props.version && (
                      <MetaBox
                        title="Status"
                        value={template.active ? 'Published ' : template.trash ? "In Trash " : "Draft "}
                      />
                    )
                  }


                  {
                    !this.props.version && this.props.current_user.role === 'admin' && (
                      <MetaBox
                        title="Created by"
                        value={creator ? creator.display_name : template.creator.display_name }
                      />
                    )
                  }

                  {
                    !this.props.version && (
                      <MetaBox
                        title="Created on"
                        value={new Date(template.created_at).toLocaleString()}
                      />
                    )
                  }

                  {
                    !this.props.version && !template.static && modifier && (
                      <React.Fragment>
                        <MetaBox
                          title="Modified by"
                          value={modifier.display_name}
                        />

                        <MetaBox
                          title="Modified on"
                          value={new Date(template.updated_at).toLocaleString()}
                        />
                      </React.Fragment>
                    )
                  }

                  {
                    this.props.version && (
                      <React.Fragment>
                        <MetaBox
                          title="Published by"
                          value={this.props.version.publisher}
                        />
                        <MetaBox
                          title="Published at"
                          value={new Date(this.props.version.published_at).toLocaleString()}
                        />
                      </React.Fragment>
                    )
                  }

                  {
                    !this.props.version && (
                      <MetaBox
                        title="ID"
                        value={template.id}
                      />
                    )
                  }

                </React.Fragment>
              )
            }

          </div>
          <Grid container spacing={24} justify="flex-end">
            {
              this.props.current_user.role === 'admin' && !template.static && !this.props.version && !template.active && !template.trash && (
                <Button className="buttonnoto c-blue" component={Link} to={`/templates/${template.id}/edit`} target="_blank">Edit</Button>
              )
            }

            <Button className="buttonnoto c-blue" onClick={this.props.handleClose}>Close</Button>

          </Grid>
        </DialogContent>
      </Dialog>
    )
  }
}

const TemplatePreview=connect(mapStateToProps, mapDispatchToProps)(ConnectedTemplatePreview)
export default TemplatePreview



// WEBPACK FOOTER //
// ./src/js/components/TemplatePreview.js